import React from "react";
import "../styles/oldmsgloader.css";

const oldMessageLoader = () => {
  return <div className="oldloader"></div>
};

export default oldMessageLoader;
